import { doSignInWithEmailAndPassword } from "../../firebase/auth";
import { useAuth } from "../../contexts/authContext/authContext";
import { useRef } from "react";
import MainPage from '../MainPage/MainPage'

const LoginPage = () => {
  const { userLoggedIn } = useAuth();
  const inputEmail = useRef(null);
  const inputPassword = useRef(null);

  console.log(useAuth());

  async function signIn(email, password) {
    try {
      await doSignInWithEmailAndPassword(
        email, password
      );
    } catch (error) {
      console.error("Error signing in:", error);
    }
  }


  const handleLogin = (e) => {
    e.preventDefault();
    signIn(inputEmail.current.value, inputPassword.current.value);
  }

  return (
    <>
      {!userLoggedIn ? (
        <>
          <h1>Hi Daniel!</h1>
          <form onSubmit={handleLogin}>
            <label htmlFor="email">Email</label>
            <br></br>
            <input type="text" id="email" name="email" ref={inputEmail}></input>
            <br></br>
            <label htmlFor="password">Password:</label>
            <br></br>
            <input
              type="text"
              id="password"
              name="password"
              ref={inputPassword}
            ></input>
            <input type="submit" value="Login"></input>
          </form>
        </>
      ) : (
        <MainPage isEditable={userLoggedIn} />
      )}
    </>
  );
}

export default LoginPage;